import React, { Component } from "react";

class NotFoundPage extends Component {
  render() {
    return (
      <div>
        <h2>Oh no!</h2>
        <h3>Error 404: Page Not Found</h3>
      </div>
    );
  }
}

export default NotFoundPage;
